import { render } from "./teaArtEventClub.vue?vue&type=template&id=d27ce5b2"
import script from "./teaArtEventClub.vue?vue&type=script&lang=js"
export * from "./teaArtEventClub.vue?vue&type=script&lang=js"

import "./teaArtEventClub.vue?vue&type=style&index=0&id=d27ce5b2&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__